// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.design-jobs .actions {
  padding: 12px 20px !important;
}
.design-jobs .p-datatable > .p-datatable-wrapper {
  overflow: auto;
  width: 100%;
  height: calc(100vh - 200px);
}
@media only screen and (max-width: 1024px) {
  .design-jobs .p-datatable > .p-datatable-wrapper {
    height: calc(100vh - 200px);
  }
}
.design-jobs .header-buttons {
  gap: 6px;
  align-items: center;
  display: flex;
  flex-direction: row;
}
.design-jobs .header-buttons .downloadAll-btn {
  vertical-align: text-top;
  background: transparent;
  border: none;
}
.design-jobs .header-buttons .downloadAll-btn i {
  font-size: 1.3rem;
}
.design-jobs .header-buttons .header-icons {
  margin-left: 10px;
  min-height: 20px;
}

.no-image-icon {
  font-size: 1.8rem;
}

.visual-img {
  width: 50px;
  height: 50px;
}

.infoButton {
  background: transparent;
  border: none;
  vertical-align: -webkit-baseline-middle;
  margin-left: 5px;
}

.status-icons {
  cursor: unset !important;
  position: unset !important;
  width: unset !important;
  height: unset !important;
  font-size: 1.8rem;
  font-weight: 800;
}

.force-btn {
  background-color: rgb(0, 176, 80);
  color: white;
  border: none;
  border-radius: 5px;
  padding: 8px 10px;
  margin: 2px 0;
}
.force-btn[disabled] {
  cursor: unset;
  background-color: rgb(189, 235, 210);
}
.force-btn .pi-check {
  font-weight: 800;
}

.download-btn {
  background-color: transparent;
  border: none;
  margin: 2px 0;
}
.download-btn[disabled] {
  cursor: unset;
  color: #d3d3d3;
}
.download-btn .pi-check {
  font-weight: 800;
}

.force-warning-popup {
  width: 50vw;
}
.force-warning-popup .p-dialog-header .p-dialog-title {
  word-break: normal;
}

.download_icon {
  cursor: pointer;
  padding-right: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/DesignJob/index.scss"],"names":[],"mappings":"AAGE;EACE,6BAAA;AAFJ;AAKE;EACE,cAAA;EACA,WATO;EAUP,2BAAA;AAHJ;AAKI;EALF;IAMI,2BAAA;EAFJ;AACF;AAKE;EACE,QAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAHJ;AAKI;EACE,wBAAA;EACA,uBAAA;EACA,YAAA;AAHN;AAKM;EACE,iBAAA;AAHR;AAOI;EACE,iBAAA;EACA,gBAAA;AALN;;AAUA;EACE,iBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;AAPF;;AAUA;EACE,uBAAA;EACA,YAAA;EACA,uCAAA;EACA,gBAAA;AAPF;;AAUA;EACE,wBAAA;EACA,0BAAA;EACA,uBAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,iCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;AAPF;AASE;EACE,aAAA;EACA,oCAAA;AAPJ;AAUE;EACE,gBAAA;AARJ;;AAYA;EACE,6BAAA;EACA,YAAA;EACA,aAAA;AATF;AAWE;EACE,aAAA;EACA,cAAA;AATJ;AAYE;EACE,gBAAA;AAVJ;;AAcA;EACE,WAAA;AAXF;AAcI;EACE,kBAAA;AAZN;;AAiBA;EACE,eAAA;EACA,mBAAA;AAdF","sourcesContent":["$width100: 100%;\n\n.design-jobs {\n  .actions {\n    padding: 12px 20px !important;\n  }\n\n  .p-datatable > .p-datatable-wrapper {\n    overflow: auto;\n    width: $width100;\n    height: calc(100vh - 200px);\n\n    @media only screen and (max-width: 1024px) {\n      height: calc(100vh - 200px);\n    }\n  }\n\n  .header-buttons {\n    gap: 6px;\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n\n    .downloadAll-btn {\n      vertical-align: text-top;\n      background: transparent;\n      border: none;\n      \n      i {\n        font-size: 1.3rem;\n      }\n    }\n\n    .header-icons {\n      margin-left: 10px;\n      min-height: 20px;\n    }\n  }\n}\n\n.no-image-icon {\n  font-size: 1.8rem;\n}\n\n.visual-img {\n  width: 50px;\n  height: 50px;\n}\n\n.infoButton {\n  background: transparent;\n  border: none;\n  vertical-align: -webkit-baseline-middle;\n  margin-left: 5px;\n}\n\n.status-icons {\n  cursor: unset !important;\n  position: unset !important;\n  width: unset !important;\n  height: unset !important;\n  font-size: 1.8rem;\n  font-weight: 800;\n}\n\n.force-btn {\n  background-color: rgb(0,176,80);\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 8px 10px;\n  margin: 2px 0;\n\n  &[disabled] {\n    cursor: unset;\n    background-color: rgb(189,235,210);\n  }\n\n  .pi-check {\n    font-weight: 800;\n  }\n}\n\n.download-btn {\n  background-color: transparent;\n  border: none;\n  margin: 2px 0;\n\n  &[disabled] {\n    cursor: unset;\n    color: #d3d3d3;\n  }\n\n  .pi-check {\n    font-weight: 800;\n  }\n}\n\n.force-warning-popup {\n  width: 50vw;\n\n  .p-dialog-header {\n    .p-dialog-title {\n      word-break: normal;\n    }\n  }\n}\n\n.download_icon {\n  cursor: pointer;\n  padding-right: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
